import "./style/Coaches.css";

import PlayerForm from "./PopupForm/PlayerForm";
import { useEffect, useState } from "react";
import DeletePopup from "./PopupForm/DeletePopup";

// import {GrView} from "react-icons/gr";
import { FiEdit } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { downloadPlayersCsv, getAllPlayers, getTotalPlayers } from "../apicalls/players";
import { isAuthenticated } from "../apicalls/auth";
import Paginations from "./Paginations";
import debounce from "lodash.debounce";

function Players() {
  const [temp, setTemp] = useState([]);

  const [addpopup, setaddPopup] = useState(false);
  const [editpopup, seteditPopup] = useState(false);
  const [deletepopup, setdeletePopup] = useState(false);
  const [players, setPlayers] = useState([]);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [stripeId, setStripeId] = useState("");
  const [total, setTotal] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);

  const user = isAuthenticated();
  const accessToken = user?.access_token;
  const hasFilters = Boolean(search || email || phone || stripeId);

  const handleChange = (e) => {
    setPerPage(e.target.value);
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;

    setCurrentPage(1);
    if (name === "email") {
      setEmail(value);
    } else if (name === "phone") {
      setPhone(value);
    } else if (name === "stripeId") {
      setStripeId(value);
    } else {
      setSearch(value);
    }
  };
  const deBounceOnChange = debounce(handleSearch, 500);

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    getAllPlayers(currentPage, PerPage, search, accessToken, {
      email,
      phone,
      stripeId,
    }).then(
      (data) => {
        setPlayers(data);
      }
    );

    getTotalPlayers(accessToken).then((data) => {
      setTotal(data);
      let temp2 = [];
      for (let i = currentPage; i <= Math.ceil(data.length / 10); i++) {
        temp2.push(i * 10);
      }
      setTemp(temp2);
    });
  }, [addpopup, editpopup, deletepopup, PerPage, search, email, phone, stripeId, currentPage, accessToken]);

  // const indexOfLast = currentPage * PerPage;
  // const indexOfFirst = indexOfLast - PerPage;
  // const current =
  //   players.length > 0 ? players?.slice(indexOfFirst, indexOfLast) : players;

  const paginate = (number) => {
    setCurrentPage(number);
  };

  const saveBlobFile = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleDownloadPlayersCsv = async () => {
    if (!accessToken || isDownloadingCsv) {
      return;
    }

    setIsDownloadingCsv(true);
    try {
      const response = await downloadPlayersCsv(accessToken);
      if (!response.ok) {
        throw new Error("Failed to download players CSV.");
      }

      const csvBlob = await response.blob();
      saveBlobFile(csvBlob, "players.csv");
    } catch (error) {
      console.log(error);
      alert("Unable to download players CSV.");
    } finally {
      setIsDownloadingCsv(false);
    }
  };

  return (
    <main>
      <div className="coaches_title">
        <h1>Players</h1>
        <div className="players_title_actions">
          <button
            className="coaches_button"
            onClick={handleDownloadPlayersCsv}
            disabled={isDownloadingCsv}
          >
            {isDownloadingCsv ? "Downloading..." : "Download CSV"}
          </button>
          <button
            className="coaches_button"
            onClick={() => {
              setaddPopup(true);
            }}
          >
            Add Player +
          </button>
        </div>
      </div>
      {addpopup && <PlayerForm action="Add" setPopup={setaddPopup} />}
      <div className="filter">
        {currentPage > 1 ? (
          ""
        ) : (
          <div>
            <select name="" id="" onChange={handleChange}>
              {temp.map((val) => {
                return (
                  <option key={val} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
            <span>
              {" "}
              show {PerPage} out of {total?.length}
            </span>
          </div>
        )}
        <input
          className="w-25"
          type="text"
          name="search"
          onChange={deBounceOnChange}
          placeholder="Search name"
        />
        <input
          className="w-25"
          type="email"
          name="email"
          onChange={deBounceOnChange}
          placeholder="Email"
        />
        <input
          className="w-25"
          type="text"
          name="phone"
          onChange={deBounceOnChange}
          placeholder="Phone"
        />
        <input
          className="w-25"
          type="text"
          name="stripeId"
          onChange={deBounceOnChange}
          placeholder="Stripe ID"
        />
      </div>

      <div className="col-11">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">phone no.</th>
                <th scope="col">Gender</th>
                <th scope="col">Start Rating</th>
                <th scope="col">Current Rating</th>
                <th scope="col">Matches</th>
                <th scope="col">Stripe ID</th>
                <th scope="col">Edit</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {players.length > 0 ? (
                players.map((player) => {
                  return (
                    <tr key={player.user_id}>
                      <td className="fw-bold">
                        <img
                          src={player.profile_picture}
                          alt=""
                          id="table_img"
                        />{" "}
                        {player.full_name}
                        <span className="text-danger fw-normal">
                          {player.is_deleted ? " ( deleted player )" : ""}
                        </span>
                      </td>
                      <td>{player.email}</td>
                      <td>{player.phone}</td>
                      <td>{player.rating_gender || "-"}</td>
                      <td>{player.starting_rating ?? player.self_rated_seed ?? "-"}</td>
                      <td>{player.current_rating ?? "-"}</td>
                      <td>{player.matches_played ?? 0}</td>
                      <td>{player.stripe_customer_id}</td>

                      <td>
                        <FiEdit
                          className="icon-cursor"
                          onClick={() => {
                            seteditPopup(player.user_id);
                          }}
                        />
                        {editpopup === player.user_id && (
                          <PlayerForm
                            player_id={player.user_id}
                            action="Edit"
                            // person="Player"
                            setPopup={seteditPopup}
                          />
                        )}
                      </td>
                      {!player.is_deleted ? (
                        <td>
                          <AiOutlineDelete
                            className="icon-cursor"
                            onClick={() => {
                              setdeletePopup(player.user_id);
                            }}
                          />
                          {deletepopup === player.user_id && (
                            <DeletePopup
                              player_id={player.user_id}
                              setPopup={setdeletePopup}
                            />
                          )}
                        </td>
                      ) : (
                        <span className="text-danger">deleted</span>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td>
                    <h2>Players not Available</h2>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {hasFilters ? (
          " "
        ) : (
          <Paginations
            perPage={PerPage}
            total={total?.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        )}
      </div>
    </main>
  );
}

export default Players;
